// extracted by mini-css-extract-plugin
module.exports = {"main_nav":"nav-list_main_nav__33XRD","nested_nav":"nav-list_nested_nav__VXxdO"};